// 27KH #109219 add
import { getMessage } from "common/messageUtil"
import { magiContants } from "utils/contants"

export const initialValues = {
  loginPermissionIpAddressSetting: '',
  loginPermissionIpAddressV6Setting: '',
  // 27KH #11085 start
  companySysVersionNumber: '',
  // 27KH #11085 end
}

export const listener = (ev: {
  preventDefault: () => void
  returnValue: string
}) => {
  ev.preventDefault()
  ev.returnValue = getMessage(magiContants.MESSAGECODE_MCBMS010_002)
}